import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./DishesListComponent.module.css";
import { dishesActions } from "../../../store/slices/dishes-slices";
import DishComponent from "../DishComponent/DishComponent";
import Loader from "../../ui/Loader/Loader";
import { Pagination } from "../../../ui";

const DishesListComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { dishesA, trigger, filterParams, status } = useSelector(
    (store) => store.dishes
  );
  const { page } = useSelector((store) => store.pagination);

  const { totalPages, data: dishes, total } = dishesA || {};

  useEffect(() => {
    dispatch(dishesActions.getAllDishesPaginated({ page, ...filterParams }));
  }, [trigger, page, filterParams, dispatch]);

  // Show loading state when status is Loading or when dishesA is undefined (initial load)
  const isLoading = status === "Loading" || !dishesA;

  return (
    <section className={css.wrap}>
      <section className={css.header}>
        <div className={css.image}>{t("Image")}</div>
        <div className={css.name}>{t("modal-name-input-new-category")}</div>
        <div className={css.weight}>{t("Weight")}</div>
        <div className={css.weightNetto}>{t("weight-netto")}</div>
        <div className={css.price}>{t("modal-price")}</div>
        <div className={css.cost}>{t("Cost")}</div>
        <div className={css.category}>{t("Category")}</div>
        <div className={css.actions}>{t("Actions")}</div>
      </section>

      <div className={css.dishesContainer}>
        {isLoading ? (
          <div className={css.loadingContainer}>
            <Loader text={t("Loading dishes...")} />
          </div>
        ) : status === "rejected" ? (
          <div className={css.noResults}>{t("Error loading dishes")}</div>
        ) : dishes && dishes.length > 0 ? (
          dishes.map((obj) => <DishComponent key={obj.id} dish={obj} />)
        ) : (
          <div className={css.noResults}>
            {filterParams.word
              ? t("No dishes found matching your search")
              : t("No dishes available")}
          </div>
        )}
      </div>

      <div className={css.blockPagination}>
        <Pagination totalPages={totalPages || 0} totalItems={total || 0} />
      </div>
    </section>
  );
};

export default React.memo(DishesListComponent);
